var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"autocomplete":"off"}},[_c('md-card',[_c('md-card-header',{staticClass:"md-card-header-icon md-card-header-green"},[_c('div',{staticClass:"card-icon"},[_c('md-icon',[_vm._v(_vm._s(_vm.formIcon))])],1),_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),(_vm.everythingLoaded)?_c('md-card-content',[_c('ValidationProvider',{attrs:{"name":"name","rules":"required|min:2"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var passed = ref.passed;
var failed = ref.failed;
return [_c('md-field',{class:[{ 'md-error': failed }, { 'md-valid': passed }]},[_c('label',[_vm._v("Naam")]),_c('md-input',{attrs:{"type":"text"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_c('slide-y-down-transition',[_c('md-icon',{directives:[{name:"show",rawName:"v-show",value:(failed),expression:"failed"}],staticClass:"error"},[_vm._v("close")])],1),_c('slide-y-down-transition',[_c('md-icon',{directives:[{name:"show",rawName:"v-show",value:(passed),expression:"passed"}],staticClass:"success"},[_vm._v("done")])],1)],1)]}}],null,false,7452760)}),_c('ValidationProvider',{attrs:{"name":"order","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var passed = ref.passed;
var failed = ref.failed;
return [_c('md-field',{class:[{ 'md-error': failed }, { 'md-valid': passed }]},[_c('label',[_vm._v("Volgorde")]),_c('md-select',{attrs:{"name":"order","id":"order","required":"","disabled":_vm.requesting},model:{value:(_vm.order),callback:function ($$v) {_vm.order=$$v},expression:"order"}},_vm._l(([
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                33,
                34,
                35,
                36,
                37,
                38,
                39,
                40,
                41,
                42,
                43,
                44,
                45,
                46,
                47,
                48,
                49,
                50,
                51,
                52,
                53,
                54,
                55,
                56,
                57,
                58,
                59,
                60,
                61,
                62,
                63,
                64,
                65,
                66,
                67,
                68,
                69,
                70,
                71,
                72,
                73,
                74,
                75,
                76,
                77,
                78,
                79,
                80,
                81,
                82,
                83,
                84,
                85,
                86,
                87,
                88,
                89,
                90,
                91,
                92,
                93,
                94,
                95,
                96,
                97,
                98,
                99
              ]),function(orderOption,index){return _c('md-option',{key:index,attrs:{"value":orderOption}},[_vm._v(_vm._s(orderOption))])}),1),_c('slide-y-down-transition',[_c('md-icon',{directives:[{name:"show",rawName:"v-show",value:(failed),expression:"failed"}],staticClass:"error"},[_vm._v("close")])],1),_c('slide-y-down-transition',[_c('md-icon',{directives:[{name:"show",rawName:"v-show",value:(passed),expression:"passed"}],staticClass:"success"},[_vm._v("done")])],1)],1)]}}],null,false,2178688662)}),[_c('h4',{staticClass:"card-title"},[_vm._v("Rollen")]),_c('p',[_vm._v(" Gebruikers met de volgende rollen krijgen de extra invoer velden die aan deze groep zijn toegevoegd. ")]),_vm._l((_vm.allRolesBooleans),function(role,index){return [_c('md-switch',{key:index,attrs:{"disabled":!_vm.canChangeRole(_vm.allRoles[index].id)},model:{value:(_vm.allRolesBooleans[index]),callback:function ($$v) {_vm.$set(_vm.allRolesBooleans, index, $$v)},expression:"allRolesBooleans[index]"}},[_vm._v(" "+_vm._s(_vm.allRoles[index].label)+" ")])]})]],2):_vm._e(),_c('md-card-actions',[_c('md-button',{class:{
          'md-primary': !_vm.formTouched,
          'md-warning': _vm.formTouched
        },attrs:{"native-type":"button"},nativeOn:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_vm._v("Terug")]),_c('md-button',{staticClass:"md-success",attrs:{"disabled":!_vm.formTouched,"native-type":"submit"},nativeOn:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Opslaan")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }